export default {
  title: 'Menuens redigeringshistorik',
  subtitle: 'Se, hvem der har ændret priser, tilgængelighed og synlighed for {{company}} – og hvornår.',
  filters: {
    type: {
      label: 'Type',
    },
    item: {
      placeholder: 'Alle varer',
    },
    event: {
      label: 'Hændelse',
    },
  },
  columns: {
    when: 'Hvornår',
    who: 'Ændret af',
    type: 'Type',
    item: 'Vare',
    event: 'Hændelse',
    changes: 'Ændringer',
  },
  types: {
    product: 'Produkt',
    modifier: 'Tilvalg',
    category: 'Kategori',
    modifier_group: 'Tilvalgsgruppe',
    menu: 'Menu',
  },
  events: {
    created: 'Oprettet',
    updated: 'Opdateret',
    deleted: 'Slettet',
  },
  fields: {
    name: 'Navn',
    description: 'Beskrivelse',
    price: 'Pris',
    is_available: 'Tilgængelighed',
    is_visible: 'Synlighed',
    is_available_for_pickup: 'Tilgængelighed til afhentning',
    is_available_for_delivery: 'Tilgængelighed til levering',
    tax_category_id: 'Momskategori',
    schedule: 'Visningstider',
    is_required: 'Påkrævet',
    max_count: 'Maks. valg',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Afhentningspris',
    delivery: 'Leveringspris',
    dine_in: 'Pris for spisning på stedet',
    room_service: 'Pris for roomservice',
  },
  booleans: {
    on: 'Tilgængelig',
    off: 'Ikke tilgængelig',
    yes: 'Ja',
    no: 'Nej',
  },
  schedule: {
    always: 'Altid',
    every_day: 'Hver dag',
  },
  pagination: {
    previous: 'Forrige',
    next: 'Næste',
  },
  causers: {
    undo: 'Fortryd',
    orders_terminal: 'Ordreterminal',
    approved_by: {
      amigo: 'Amigo, godkendt af {{name}}',
      assistant: 'Assistent, godkendt af {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Åbn i Amigo-loggen',
  system: 'System',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Menuens redigeringshistorik kunne ikke indlæses',
  },
};
